import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=eca92da8&"
import script from "./ImagePreview.vue?vue&type=script&lang=js&"
export * from "./ImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eca92da8')) {
      api.createRecord('eca92da8', component.options)
    } else {
      api.reload('eca92da8', component.options)
    }
    module.hot.accept("./ImagePreview.vue?vue&type=template&id=eca92da8&", function () {
      api.rerender('eca92da8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/EditAttachments/ImagePreview.vue"
export default component.exports